<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    :return-value.sync="dateValue"    
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="dateValue"
        :label= "pickerLabel"
        append-icon="mdi-calendar"
        readonly
        clearable
        v-on="on"
      />
    </template>
    <v-date-picker
      v-model="dateValue"
      :show-current="showCurrent"
      :disabled="isDisabled"
      no-title
      scrollable
    >
      <v-spacer />
      <v-btn
        text
        color="primary"
        @click="menu = false"
      >
        Cancel
      </v-btn>     
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: 'DatePicker',
  components: {},
  props: {
    pickerLabel: String,
    dateValue: String,
    isDisabled: Boolean  
  },
  data: () => ({
    showCurrent: true,
    menu: false,
    modal: false
  }),
  watch: {
    dateValue (val) {
      this.$emit('dateSelected',val); this.$refs.menu.save(val);
    },
  },
  computed: {},
  methods: {}
}
</script>